module.exports = {"id":"220651","name":"Angeliño","rating":"71","photo":"./data/images/photos/3/220651.png","club":{"name":"NAC Breda","logo":"./data/images/clubs/NACBreda.png"},"positions":["DG","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Angelino0.json
// module id = 416
// module chunks = 0